var t = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, a = function(e, r, l, s) {
  return t[e];
};
const p = a;
export {
  p as default
};
